module.exports = __webpack_public_path__ + "img/ab21d0cc157243d466d37ffce56f7fbf.png";